export default "__VITE_ASSET__BlDczgph__"